import React, { useRef, useEffect } from 'react';
import './Contact.css';
import contactImage from '../assets/images/2024publicspeakingphotos/1.png';

const Contact = () => {
    const titleRef = useRef(null);
    
    useEffect(() => {
        titleRef.current.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
        });
    }, []);

    return (
        <div className="contact-page" ref={titleRef}>
            <section className="contact-hero">
                <h1>Contact Us</h1>
            </section>

            <div className="contact-card">
                <div className="contact-image-container">
                    <img src={contactImage} alt="Clean Air Student Council" className="contact-image" />
                </div>
                <div className="contact-content">
                    <h2>Connect with CASC!</h2>
                    <p className="contact-text">
                        If you have any queries or concerns, don't hesitate to let us know! 
                        Drop us an email and we'll get in touch as soon as possible.
                    </p>
                    <p className="contact-email">
                        cleanairstudentcouncil@hongkongcan.org
                    </p>
                    <a 
                        href="https://forms.gle/NcApYPxqPBobXpz6A" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="contact-link"
                    >
                        Sign up here to receive latest event and recruitment updates!
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Contact;